<template>
    <card-sections :title="Lang.get('employerdashboard::pages/settings/provider.status.title')"
                   :subtitle="Lang.get('employerdashboard::pages/settings/provider.status.subtitle')"
                   :tabName="'provider'">

        <h2>{{ Lang.get('employerdashboard::pages/settings/provider.files.detail.title', { id: file.id }) }}</h2>

        <a
            class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4 mt-4"
            :href="route('nl.employerdashboard.settings.provider.status', { company_as_uuid: company_uuid })"
        >
            {{ Lang.get('employerdashboard::pages/settings/provider.files.detail.go_back') }}
        </a>

        <table class="table table-bordered table-light table-striped mt-3">
            <thead>
                <tr>
                    <th>{{ Lang.get('employerdashboard::pages/settings/provider.files.detail.table.headings.row') }}</th>
                    <th>{{ Lang.get('employerdashboard::pages/settings/provider.files.detail.table.headings.error') }}</th>
                </tr>
            </thead>
                <tbody>
                    <tr v-for="error in errors">
                        <td>{{ error.rowNumber }} </td>
                        <td>{{ error.error }} </td>
                    </tr>
            </tbody>
        </table>
    </card-sections>
</template>

<script>
import Layout from '@/Shared/Layout'
import CardSections from './Shared/CardSections';

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/settings/provider.files.detail.title'),
        }
    },
    components: {
        CardSections,
        Layout,
    },
    props: {
        file: Object,
        errors: Array,
        company_uuid: String,
    }
}
</script>
